import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  EventEmitter,
  OnDestroy
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

//Services
import { NavBarService } from "app/core/services/nav-bar.service";
import { CourseService } from "app/core/services/course.service";
import { TlaService } from "app/core/services/tla.service";
import { CourseOutcomeService } from "app/core/services/course-outcome.service";
import { MappingService } from "app/core/services/mapping.service";
import { AssessmentService } from "app/core/services/assessment.service";
import { QuestionService } from "app/core/services/question.service";
import { ProgramOutcomeService } from "app/core/services/program-outcome.service";
import { UserService } from "app/core/services/user.service";

import { CurrentUserService } from "app/core/services/current-user.service";

//Models
import { TlaFormat } from "app/core/models/tla-format";
import { AssessmentTimingOption } from "app/core/models/assessment-timing-option";
import { AssessmentLevelOption } from "app/core/models/assessment-level-option";
import { AssessmentFormat } from "app/core/models/assessment-format";
import { TlaSelectedOption } from "app/core/models/tla-selected-option";
import { Loading } from "app/core/models/loading";
import { UserCourse } from "app/core/models/user-course";
import { ProgramOutcome } from "app/core/models/program-outcome";
import { Level } from "app/core/models/level";

import { ProgramOutcomeCategory } from "app/core/models/program-outcome-category";
import { Question } from "app/core/models/question";
import { QuestionAnswerOption } from "app/core/models/question-answer-option";
import { CurriculumReview } from "app/core/models/curriculum-review";
import { UserStep } from "app/core/models/user-step";
import { User } from "app/core/models/user";

//Components
import { UserStepMappingComponent } from "../user-step-mapping/user-step-mapping.component";
import { CustomError } from "app/core/models/custom-error";
import { Observable, Subscription } from "rxjs";
import { UserStepCourseOutcomeComponent } from "../user-step-course-outcome/user-step-course-outcome.component";

@Component({
  selector: "app-user-course",
  templateUrl: "./user-course.component.html",
  styleUrls: ["./user-course.component.scss"]
})
export class UserCourseComponent implements OnInit, OnDestroy {
  //data
  courseId: number;
  userCourse: UserCourse;
  currentStep: string;
  curriculumReview: CurriculumReview;
  numCourses: number;

  //program outcomes
  programOutcomes: Array<ProgramOutcome> = [];
  programOutcomeCategories: Array<ProgramOutcomeCategory> = [];

  //mapping levels
  levels: Array<Level> = [];

  // assessmentMethodValues: Array<AssessmentMethodValue> = [];

  /////////// Assessment variables //////////////////////

  assessmentFormat: AssessmentFormat;
  assessmentLevelOptions: Array<AssessmentLevelOption> = [];
  assessmentTimingOptions: Array<AssessmentTimingOption> = [];

  //this will be updated by assessment step component and passed on to child components: Assessment and outcomes
  // selectedAssessmentMethods: Array<AssessmentMethodValue> = [];
  // selectedAssessmentTotalWeight: number = 0;

  /////////// TLA variables ///////////////////

  //this will be updated by tla step component and passed on to outcomes step
  // selectedCourseTlaValues: Array<TlaOptionValue> = [];

  tlaFormat: TlaFormat;
  // tlaOptions: Array<TlaOption> = [];
  // tlaExtentOptions: Array<TlaExtentOption> = [];
  // tlaOptionValue: TlaOptionValue;

  ///////// Course outcomes variables /////////////

  //this will be updated by course outcome step
  // courseOutcomes: Array<CourseOutcomeValue> = [];

  loadedSteps = {
    assessment: false,
    tla: false,
    outcome: false,
    mapping: false,
    question: false,
    summary: false
  };
  completedSteps = {
    assessment: false,
    tla: false,
    outcome: false,
    mapping: false,
    question: false,
    summary: false
  };
  unsavedSteps = { question: false };

  loading: Loading;

  //in progress modal text
  shouldShowInProgressModal: boolean = false;
  inProgressModalText: string;
  inProgressStatus: string;

  //timestamp of last updated. When it's updated, it forces child components to update.
  // Used by course outcomes step - if a new course outcome is added, outcome mapping step should be updated, including status
  courseOutcomesChanged: number;

  courseQuestions: Array<Question> = [];

  //errors

  loadError: CustomError;

  actionErrorTitle: string = "Error";
  actionErrors: Array<CustomError> = [];

  //flags
  ploLoaded: boolean = false;
  categoriesLoaded: boolean = false;

  //menu item array
  userSteps: Array<UserStep> = [];
  currentStepIndex: number = 0;

  currentUser: User;

  //subscriptions
  currentUserSubscription: Subscription;
  routerSubscription: Subscription;

  isNavigationDisabled: boolean = false;

  @ViewChild(UserStepMappingComponent)
  private mappingStepComponent: UserStepMappingComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private courseService: CourseService,
    private tlaService: TlaService,
    private programOutcomeService: ProgramOutcomeService,
    private courseOutcomeService: CourseOutcomeService,
    private mappingService: MappingService,
    private assessmentService: AssessmentService,
    private questionService: QuestionService,
    private navBarService: NavBarService,
    private userService: UserService,
    private currentUserService: CurrentUserService
  ) { }

  async ngOnInit() {
    // console.log("User course component");

    this.loading = new Loading(true, "Loading Course...");

    this.courseId = this.route.snapshot.params["courseId"];

    this.currentUserSubscription = this.currentUserService.currentUser.subscribe(
      currentUser => {
        // console.log(currentUser);

        // this.routerSubscription = this.route.params.subscribe(
        //   (params: Params) => {
        //     this.courseId = params["courseId"];
        (async () => {
          try {
            if (currentUser.id != null) {
              //get curriculum review
              this.curriculumReview = await this.courseService.getReview(
                this.courseId
              );

              //get course information
              this.userCourse = await this.courseService.getUserCourse(
                this.courseId
              );

              if (this.userCourse.status == "Assigned") {
                //change status to "In Progress", if current status is "Assigned"
                await this.courseService.updateCourseStatus(
                  this.curriculumReview.id,
                  this.userCourse.id,
                  "In Progress"
                );

                this.userCourse.status = "In Progress";
              }

              await this.loadCourse();
              // }
            } else {
              //TODO redirect to login


            }
          } catch (error) {
            console.log(error);
            this.loadError = error;
          } finally {
            this.loading.isLoading = false;
          }
          // }
        })();
        //   }
        // );
      }
    );
  }

  async loadCourse() {
    // console.log("Load Course");
    // console.log(this.userCourse);

    try {
      //construct user steps once

      this.programOutcomeCategories = await this.programOutcomeService.getProgramOutcomeCategoriesForCourse(
        //this.curriculumReview.id
        this.courseId
      );

      //get plos
      this.programOutcomes = await this.programOutcomeService.getProgramOutcomesForCourse(
        // this.curriculumReview.id
        this.courseId
      );

      this.assessmentFormat = await this.assessmentService.getAssessmentFormatByCourseId(
        this.courseId
      );
      this.tlaFormat = await this.tlaService.getTlaFormatByCourseId(
        this.courseId
      );

      ////////////////// Construct Menu ////////////////////////////////

      //////// assessment form

      if (this.assessmentFormat.isEnabled) {
        this.userSteps.push(
          new UserStep("assessment", "Student Assessment Methods")
        );
      }

      /////// tla form

      if (this.tlaFormat.isEnabled) {
        this.userSteps.push(
          new UserStep("tla", "Teaching and Learning Activities")
        );
      }

      /////// course outcomes always required

      this.userSteps.push(new UserStep("outcome", "Course Outcomes"));

      ////// check course outcome questions

      let courseOutcomeDetailsStep: boolean = false;

      if (
        (this.assessmentFormat.isEnabled && this.assessmentFormat.requiredByCourseOutcome) ||
        (this.tlaFormat.isEnabled && this.tlaFormat.requiredByCourseOutcome)
      ) {
        courseOutcomeDetailsStep = true;
      } else {
        let outcomeQuestions = await this.questionService.getQuestionsByCourseId(
          this.courseId,
          "outcome"
        );

        // console.log(outcomeQuestions);

        if (outcomeQuestions.length > 0) {
          courseOutcomeDetailsStep = true;
        }
      }

      if (courseOutcomeDetailsStep) {
        this.userSteps.push(
          new UserStep("outcome-detail", "Course Outcome Details")
        );
      }

      /////// Outcome mapping is always required

      this.userSteps.push(new UserStep("mapping", "Course Outcomes Mapping"));

      /////// Course Questions

      let courseQuestions = await this.questionService.getQuestionsByCourseId(
        this.courseId,
        "course"
      );

      // console.log(courseQuestions);

      if (courseQuestions.length > 0) {
        this.userSteps.push(
          new UserStep("question", "Additional Questions about Course")
        );
      }

      /////// Summary
      this.userSteps.push(new UserStep("summary", "Course Summary"));

      // console.log(this.userSteps);

      ////////////// END Menu Construction /////////////////////////////////

      // const params = this.route.snapshot.params;

      this.routerSubscription = this.route.params.subscribe((params: Params) => {
        //if this course is already submitted or the project is archived, redirect to summary page
        if (
          this.userCourse.status == "Submitted" ||
          this.curriculumReview.status == "Archived"
        ) {
          this.activate("summary");
        } else {
          if (params.hasOwnProperty("stepName")) {
            // this.currentStep = params["stepName"];

            this.activate(params["stepName"]);
          } else {
            //if step is not specified, go to the 1st index in userSteps

            this.activate(this.userSteps[0].name);
          }
        }
      });

      this.loading.isLoading = false;
    } catch (error) {
      console.log(error);

      throw error;
    }
  }

  dataChanged() {
    this.courseOutcomesChanged = Date.now();
  }

  /**
   * Called by outcome step component - when a new outcome is inserted, mapping step should be set to incompleted
   *
   */
  newOutcomeInserted() {
    if (this.completedSteps.mapping) {
      this.stepCompleted("mapping", false, true);
    }
  }

  activateNext() {
    if (this.currentStepIndex + 1 != this.userSteps.length) {
      this.activate(this.userSteps[this.currentStepIndex + 1].name);
    }
  }

  activatePrev() {
    if (this.currentStepIndex > 0) {
      this.activate(this.userSteps[this.currentStepIndex - 1].name);
    }
  }

  /**
   * Set active step
   * @param stepName
   */
  activate(stepName: string) {
    // console.log("Activate");

    let stepNames = [];

    this.userSteps.forEach(step => {
      stepNames.push(step.name);
    });

    this.currentStepIndex = stepNames.indexOf(stepName);

    // console.log(this.currentStepIndex);

    if (this.currentStepIndex > -1) {
      this.currentStep = stepName;
    } else {
      this.currentStep = this.userSteps[0].name;
      this.currentStepIndex = 0;
    }

    this.router.navigate(["/user/courses", this.courseId, this.currentStep]);
  }

  //triggered when initial loading is completed
  stepLoaded(stepName: string) {
    //console.log(stepName + " loaded");

    switch (stepName) {
      case "assessment":
        this.loadedSteps.assessment = true;
        break;
      case "tla":
        this.loadedSteps.tla = true;
        break;
      case "outcome":
        this.loadedSteps.outcome = true;
        break;
      case "mapping":
        this.loadedSteps.mapping = true;
        break;
      case "question":
        this.loadedSteps.question = true;
        break;
      case "summary":
        this.loadedSteps.summary = true;
        break;
    }
  }

  /**
   * If update is true, update DB
   * @param stepName
   * @param completed
   * @param update
   */

  stepCompleted(stepName: string, completed: boolean, update: boolean) {
    switch (stepName) {
      case "assessment":
        this.completedSteps.assessment = completed;
        break;

      case "tla":
        this.completedSteps.tla = completed;
        break;

      case "outcome":
        this.completedSteps.outcome = completed;
        break;

      case "mapping":
        this.completedSteps.mapping = completed;
        break;

      case "question":
        this.completedSteps.question = completed;
        break;

      case "summary":
        this.completedSteps.summary = completed;

        break;

      default:
        break;
    }
  }

  /**
   * Disable navigation. This is called by child components.
   * @param isNavigationDisabled
   */
  disableNavigation(isNavigationDisabled: boolean) {
    this.isNavigationDisabled = isNavigationDisabled;
  }

  allStepsLoaded() {
    if (!this.loadedSteps.assessment) {
      return false;
    }

    if (!this.loadedSteps.tla) {
      return false;
    }

    if (!this.loadedSteps.question) {
      return false;
    }

    //if assessment and tla are not completed, ignore outcome and mapping loaded statuses
    if (!this.completedSteps.assessment || !this.completedSteps.tla) {
      return (
        this.loadedSteps.assessment &&
        this.loadedSteps.tla &&
        this.loadedSteps.question
      );
    } else {
      return (
        this.loadedSteps.assessment &&
        this.loadedSteps.tla &&
        this.loadedSteps.outcome &&
        this.loadedSteps.mapping &&
        this.loadedSteps.question
      );
    }
  }

  allStepsCompleted(completedSteps) {
    if (
      !this.completedSteps.assessment ||
      !this.completedSteps.tla ||
      !this.completedSteps.outcome ||
      !this.completedSteps.mapping ||
      !this.completedSteps.question
    ) {
      return false;
    }

    return true;
  }

  courseSubmitted() {
    //console.log("course submitted");
    this.userCourse.status = "Submitted";
  }

  unsavedChanges(stepName: String, unsaved: boolean) {
    switch (stepName) {
      case "question":
        this.unsavedSteps.question = unsaved;
        break;

      default:
        break;
    }
  }

  ngOnDestroy() {
    // console.log("On Destroy");
    this.currentUserSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
  }
}
